import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import OwlCarousel from 'react-owl-carousel';
import BG1 from '../../assets/images/background/work.jpg'
import BG2 from '../../assets/images/shapes/testi-bg-1-1.png'
import Breadcumb from '../Breadcumb/Main'
import {Parallax} from 'react-parallax'
import BgImg from "../../assets/images/unity.jpg"
import AB from "../../assets/images/happy-team.svg"
import Author from "../../assets/images/resources/about-four-author-1.jpg"
import TeamA from "../../assets/images/team/team-2-1.jpg"
import Testi from "../../assets/images/resources/testi-1-1.jpg"
import Client1 from "../../assets/images/resources/client-1-1.png"
import img1 from "../../assets/images/rsz_bg.jpg";
import AnimatedNumber from "animated-number-react";

const About = () => {
    const [ytShow, setytShow] = useState(false)
    const logoOptions = {
        loop: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        nav: true,
        navText: ["<span class=\"fa-solid fa-angle-left\"></span>", "<span class=\"fa-solid fa-angle-right\"></span>"],
        dots: false,
        margin: 30,
        items: 2,
        smartSpeed: 700,
        responsive: {
            0: {
                margin: 30,
                items: 2
            },
            375: {
                margin: 30,
                items: 2
            },
            575: {
                margin: 30,
                items: 3
            },
            767: {
                margin: 50,
                items: 4
            },
            991: {
                margin: 40,
                items: 5
            },
            1199: {
                margin: 80,
                items: 5
            }
        }
    }
    return (
        <>
            <Breadcumb Title="About Us" Breadcumb="ABOUT" BgImg={BgImg}/>

            <section className="section-padding--bottom section-padding--top about-five">
                <div className="container">
                    <div className="row gutter-y-60">
                        <div className="col-lg-6">
                            <div className="about-five__images">
                                <div className="about-five__images__shape"></div>
                                <img src={img1} className="wow fadeInUp"
                                     data-wow-duration="1500ms" alt="" />
                                {/*<img src={img2} alt="" />*/}
                                <div className="about-five__video">
                                    <Link to="#" onClick={() => setytShow(true)} className="video-popup">
                                        <i className="fa fa-play"></i>
                                    </Link>
                                </div>
                                <div className="about-five__images__caption count-box wow fadeInUp" data-wow-duration="1500ms">
                                    <span className="count-text"><AnimatedNumber value={15} duration={2500} formatValue={(v) => Math.round(v)} /></span>
                                    Years <br />
                                    Experience
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-five__content">
                                <div className="section-title ">
                                    <p className="section-title__text">About Our Company</p>
                                    <h2 className="section-title__title">A Proud Engineering Hub in the UK</h2>
                                </div>
                                <div className="about-five__text">
                                    BEET Technologies is a leading European IT firm specialising in IT consultancy solutions. With global reach and local expertise, we bridge the gap between the tech industries of Africa, Europe, and the United States.
                                    Our experienced recruiters are dedicated to identifying the best IT professionals and matching them with exciting career opportunities, and we take pride in a personalised approach, an extensive network, and a commitment to excellence that make the hiring process smooth and successful for clients and candidates alike.
                                    Our goal is to advance the UK’s IT industry and deliver superior IT services worldwide.
                                </div>
                                {/*<div className="about-five__text">*/}
                                {/*    System is a term used to refer to an organized collection*/}
                                {/*    symbols and processes that may be used to operate on such symbols.*/}
                                {/*</div>*/}
                                {/*<ul className="about-five__box">*/}
                                {/*    <li className="about-five__box__item gray-bg">*/}
                                {/*        <i className="about-five__box__icon icon-consulting"></i>*/}
                                {/*        <div className="about-five__box__content">*/}
                                {/*            <h3 className="about-five__box__title"><Link to="/it-consultent">IT*/}
                                {/*                Consultant</Link></h3>*/}
                                {/*            <p className="about-five__box__text">Smarter Solutions</p>*/}
                                {/*        </div>*/}
                                {/*    </li>*/}
                                {/*    <li className="about-five__box__item gray-bg">*/}
                                {/*        <i className="about-five__box__icon icon-chip"></i>*/}
                                {/*        <div className="about-five__box__content">*/}
                                {/*            <h3 className="about-five__box__title"><Link to="/team">IT Specialist</Link></h3>*/}
                                {/*            <p className="about-five__box__text">Faster Solutions</p>*/}
                                {/*        </div>*/}
                                {/*    </li>*/}
                                {/*</ul>*/}
                                {/*<div className="about-four__meta">*/}
                                {/*    <div className="about-four__author">*/}
                                {/*        <img src="assets/images/resources/about-four-author-1.jpg" alt="" />*/}
                                {/*        <div className="about-four__author__content">*/}
                                {/*            <h3 className="about-four__author__title">Etukeni Ndecha</h3>*/}
                                {/*            <div className="about-four__author__designation">Founder & CEO</div>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*    <Link to="/service-01" className="thm-btn about-four__btn"><span>Learn More</span></Link>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="about-four section-padding--top">
                <div className="container">
                    <div className="row gutter-y-60">
                        <div className="col-lg-6">
                            <div className="about-four__image">
                                <img src={AB} className="wow fadeInUp"
                                     data-wow-duration="1500ms" alt="Happy team celebrating together in the office"/>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-four__content">
                                <div className="section-title ">
                                    <p className="section-title__text">About BEET Technologies</p>
                                    <h2 className="section-title__title">Who we are</h2>
                                </div>

                                <div className="about-four__text">
                                    Founded in 2017, we operate today from Malmö (Sweden), Wolverhampton (UK), and Accra
                                    (Ghana), with customers across Europe and Africa. Together with our clients, we
                                    create long-term value that makes a real difference.
                                </div>

                                <div className="about-four__text">
                                    Our team is built on skilled professionals who are committed to continuous
                                    improvement and always ready to share their knowledge with others.
                                </div>

                                <div className="about-four__text">
                                    Most people encounter BEET Technologies several times during a typical day, often
                                    without realising it. We are there, quietly helping life work: when you manage your
                                    car's functions from an app, buy tickets online, or shop for groceries — in store or
                                    online. We are there when you use your smartphone, or book a session at the gym. In
                                    short, you will find our fingerprints across large parts of everyday life.
                                </div>

                                <div className="about-four__text">
                                    We succeed because we bring a wide range of IT skills to a wide range of customers —
                                    and because of how we see IT solutions. Not as ones and zeros, but as the result of
                                    human effort aimed at making life easier and better for people. That shapes how we
                                    approach every task: keep it simple, be straightforward, fast, and transparent.
                                </div>
                                {/*<div className="about-four__meta">*/}
                                {/*    <div className="about-four__author">*/}
                                {/*        <img src={Author} alt=""/>*/}
                                {/*        <div className="about-four__author__content">*/}
                                {/*            <h3 className="about-four__author__title">Etukeni Ndecha</h3>*/}
                                {/*            <div className="about-four__author__designation">Founder & CEO</div>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*    <Link to="/service-01" className="thm-btn about-four__btn"><span>Learn More</span></Link>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*<section className="section-padding--bottom section-padding--top">*/}
            {/*    <div className="container">*/}
            {/*        <div className="section-title text-center">*/}
            {/*            <p className="section-title__text">Our Team members</p>*/}
            {/*            <h2 className="section-title__title">Meet Our Experts</h2>*/}

            {/*        </div>*/}
            {/*        <div className="row gutter-y-30">*/}
            {/*            <div className="col-lg-3 col-md-6 col-sm-12">*/}
            {/*                <div className="team-card-one wow fadeInUp" data-wow-duration="1500ms"*/}
            {/*                     data-wow-delay="000ms">*/}
            {/*                    <div className="team-card-one__image">*/}
            {/*                        <img src={TeamA} alt=""/>*/}
            {/*                        <div className="team-card-one__social">*/}
            {/*                            <ul className="team-card-one__social__links">*/}
            {/*                                <li><Link to="#"><i className="fab fa-twitter"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-facebook"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>*/}
            {/*                            </ul>*/}
            {/*                            <div className="team-card-one__social__icon">*/}
            {/*                                <i className="fa fa-share-alt"></i>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="team-card-one__content">*/}
            {/*                        <h3 className="team-card-one__title"><Link to="#">Etukeni Ndecha</Link></h3>*/}
            {/*                        <p className="team-card-one__designation">Founder & CTO</p>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="col-lg-3 col-md-6 col-sm-12">*/}
            {/*                <div className="team-card-one wow fadeInUp" data-wow-duration="1500ms"*/}
            {/*                     data-wow-delay="100ms">*/}
            {/*                    <div className="team-card-one__image">*/}
            {/*                        <img src={TeamA} alt=""/>*/}
            {/*                        <div className="team-card-one__social">*/}
            {/*                            <ul className="team-card-one__social__links">*/}
            {/*                                <li><Link to="#"><i className="fab fa-twitter"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-facebook"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>*/}
            {/*                            </ul>*/}
            {/*                            <div className="team-card-one__social__icon">*/}
            {/*                                <i className="fa fa-share-alt"></i>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="team-card-one__content">*/}
            {/*                        <h3 className="team-card-one__title"><Link to="#">Tua Nadesh</Link></h3>*/}
            {/*                        <p className="team-card-one__designation">Senior Scrum Master</p>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="col-lg-3 col-md-6 col-sm-12">*/}
            {/*                <div className="team-card-one wow fadeInUp" data-wow-duration="1500ms"*/}
            {/*                     data-wow-delay="200ms">*/}
            {/*                    <div className="team-card-one__image">*/}
            {/*                        <img src={TeamA} alt=""/>*/}
            {/*                        <div className="team-card-one__social">*/}
            {/*                            <ul className="team-card-one__social__links">*/}
            {/*                                <li><Link to="#"><i className="fab fa-twitter"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-facebook"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>*/}
            {/*                            </ul>*/}
            {/*                            <div className="team-card-one__social__icon">*/}
            {/*                                <i className="fa fa-share-alt"></i>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="team-card-one__content">*/}
            {/*                        <h3 className="team-card-one__title"><Link to="#">Etukeni Justin</Link></h3>*/}
            {/*                        <p className="team-card-one__designation">Android Engineer - Intern</p>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="col-lg-3 col-md-6 col-sm-12">*/}
            {/*                <div className="team-card-one wow fadeInUp" data-wow-duration="1500ms"*/}
            {/*                     data-wow-delay="300ms">*/}
            {/*                    <div className="team-card-one__image">*/}
            {/*                        <img src={TeamA} alt=""/>*/}
            {/*                        <div className="team-card-one__social">*/}
            {/*                            <ul className="team-card-one__social__links">*/}
            {/*                                <li><Link to="#"><i className="fab fa-twitter"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-facebook"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-pinterest-p"></i></Link></li>*/}
            {/*                                <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>*/}
            {/*                            </ul>*/}
            {/*                            <div className="team-card-one__social__icon">*/}
            {/*                                <i className="fa fa-share-alt"></i>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="team-card-one__content">*/}
            {/*                        <h3 className="team-card-one__title"><Link to="#">Sarah Albert</Link></h3>*/}
            {/*                        <p className="team-card-one__designation">Director</p>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}
            {/*<section className="black-bg cta-two">*/}
            {/*    <Parallax bgImage={BG1} bgImageAlt=""*/}
            {/*              className="cta-two__bg section-padding-lg--top section-padding-lg--bottom" strength={300}>*/}
            {/*        <div className="container">*/}
            {/*            <div className="cta-two__inner">*/}
            {/*                <h3 className="cta-two__title">Better IT Solutions & Services*/}
            {/*                    at your <span>Fingertips</span></h3>*/}
            {/*                <Link to="/contact" className="thm-btn cta-two__btn"><span>LEarn More</span></Link>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </Parallax>*/}
            {/*</section>*/}
            {/*<section*/}
            {/*    className="section-padding--bottom section-padding--top testimonials-two background-repeat-no background-position-top-center"*/}
            {/*    style={{backgroundImage: `url(${BG2})`}}>*/}
            {/*    <div className="container">*/}
            {/*        <div className="row gutter-y-60">*/}
            {/*            <div className="col-lg-5">*/}
            {/*                <div className="testimonials-two__content">*/}
            {/*                    <div className="section-title ">*/}
            {/*                        <p className="section-title__text">Our clients</p>*/}
            {/*                        <h2 className="section-title__title">We Are Trusted*/}
            {/*                            Worldwide Peoples</h2>*/}
            {/*                    </div>*/}
            {/*                    <div className="testimonials-two__content__text">Sed ut perspiciatis unde omnis natus*/}
            {/*                        error sit*/}
            {/*                        voluptatem accusa ntium doloremque laudantium totam rem aperiamea queipsa quae*/}
            {/*                        abillo*/}
            {/*                        inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.*/}
            {/*                    </div>*/}
            {/*                    <div className="testimonials-two__content__text">Pellentesque gravida lectus vitae nisi*/}
            {/*                        luctus,*/}
            {/*                        Finibus aliquet ligula ultrices.*/}
            {/*                    </div>*/}
            {/*                    <Link to="/about" className="thm-btn testimonials-two__content__btn"><span>View All*/}
            {/*                        feedbacks</span></Link>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="col-lg-7">*/}
            {/*                <div className="testimonials-two__items">*/}
            {/*                    <div className="row gutter-y-30">*/}
            {/*                        <div className="col-lg-12">*/}
            {/*                            <div className="testimonials-one-card">*/}
            {/*                                <div className="testimonials-one-card__image">*/}
            {/*                                    <img src={Testi} alt=""/>*/}
            {/*                                </div>*/}
            {/*                                <div className="testimonials-one-card__content">*/}
            {/*                                    <div className="testimonials-one-card__text">On the other hand denounc*/}
            {/*                                        with*/}
            {/*                                        ghteo*/}
            {/*                                        indignation and dislike men who so beguiled and demoralized the*/}
            {/*                                        charms*/}
            {/*                                        of*/}
            {/*                                        pleasure*/}
            {/*                                        the momen blinded by desire cannot foresee the pain and trouble.*/}
            {/*                                    </div>*/}
            {/*                                    <h3 className="testimonials-one-card__title">Michal Rahul</h3>*/}
            {/*                                    <p className="testimonials-one-card__designation">Ul - UX Designer</p>*/}
            {/*                                    <i className="icon-right-quote testimonials-one-card__icon"></i>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                        <div className="col-lg-12">*/}
            {/*                            <div className="testimonials-one-card">*/}
            {/*                                <div className="testimonials-one-card__image">*/}
            {/*                                    <img src={Testi} alt=""/>*/}
            {/*                                </div>*/}
            {/*                                <div className="testimonials-one-card__content">*/}
            {/*                                    <div className="testimonials-one-card__text">On the other hand denounc*/}
            {/*                                        with*/}
            {/*                                        ghteo*/}
            {/*                                        indignation and dislike men who so beguiled and demoralized the*/}
            {/*                                        charms*/}
            {/*                                        of*/}
            {/*                                        pleasure*/}
            {/*                                        the momen blinded by desire cannot foresee the pain and trouble.*/}
            {/*                                    </div>*/}
            {/*                                    <h3 className="testimonials-one-card__title">Jessica Brown</h3>*/}
            {/*                                    <p className="testimonials-one-card__designation">Ul - UX Designer</p>*/}
            {/*                                    <i className="icon-right-quote testimonials-one-card__icon"></i>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}
            {/*<div className="client-carousel client-carousel--two">*/}
            {/*    <div className="container">*/}
            {/*        <OwlCarousel className="thm-owl__carousel" {...logoOptions}>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*            <div className="item">*/}
            {/*                <img src={Client1} alt=""/>*/}
            {/*            </div>*/}
            {/*        </OwlCarousel>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </>
    )
}

export default About